<template>
  <el-card v-loading="loading" class="box-card summary" style="min-height: 22.8em">
    <div slot="header" class="clearfix">
      <span>Summary pay of <span style="font-weight: bold">{{ personnel['person_info']['realname'] }}</span></span>
    </div>
    <div style="font-family: monospace; font-size: 18px" >
      <el-row>
        <el-col :xs="15" :sm="17" :md="17" :lg="17">
          <table class="summary-table" width="100%">
            <tr>
              <td>Salary</td>
              <td class="summary-amount">{{ Number(salary).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
            <tr>
              <td>ACA + PERA</td>
              <td class="summary-amount"> + {{ Number(totalbenefits).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
            <!--tr v-if="totalOtherBenefits > 0">
              <td>Other Benefit</td>
              <td class="summary-amount"> + {{ Number(totalOtherBenefits).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr-->
            <tr>
              <!--td v-if="totalOtherBenefits > 0" class="SBTotal">(Salary + ACA & PERA + Other Benefit)</td-->
              <td class="SBTotal">(Salary + ACA & PERA)</td>
              <td class="SBTotal summary-amount">{{ Number(SBtotal).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
            <tr v-if="withoutpay">
              <td>Without Pay</td>
              <td class="summary-amount"> - {{ Number(withoutpay).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
            <tr>
              <td>Deductions</td>
              <td class="summary-amount"> - {{ Number(totaldeductions).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
            <tr>
              <td class="SBTotal">Net Pay</td>
              <td class="SBTotal summary-amount">{{ Number(netpay).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</td>
            </tr>
          </table>
        </el-col>
        <el-col v-if="(5000 - netpay)>0" :xs="6" :sm="6" :md="6" :lg="9">
          <div style="padding-top: 30%; padding-left: 20px">
            <p :class="((5000 - netpay)>0)? 'up-extra':'down-extra'" style="border: solid 1px;padding-left: 8px">Extra  {{ Number(5000 - netpay).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
// import { EmpBenefits } from '@/api/payroll/empbenefits'
// import { EmpDeduction } from '@/api/payroll/empdeduction'
import { SummaryPayroll } from '../../../api/payroll/summarypayroll'
export default {
  name: 'PersonnelPayrollSummary',
  props: {
    personnel: {
      default: null,
      type: Object,
      required: true
    },
    withoutpay: {
      default: null,
      type: Number,
      required: false
    }
  },
  data() {
    return {
      tenure: parseInt(this.$store.getters.APStatus),
      summary: {},
      loading: false,
      total: {},
      totalOtherBenefits: 0,
      totalbenefits: 0,
      total_honorarium: 0,
      totaldeductions: 0,
      salary: parseFloat(this.personnel.salary),
      SBtotal: 0,
      netpay: 0,
      person: null
    }
  },
  watch: {
    person: function() {
      this.SBtotal = this.salary + parseFloat(this.totalbenefits) // + parseFloat(totalOtherBenefits)
      if (this.withoutpay) {
        this.netpay = parseFloat(this.SBtotal) - parseFloat(this.totaldeductions + this.withoutpay)
      } else {
        this.netpay = parseFloat(this.SBtotal) - parseFloat(this.totaldeductions)
      }
      this.loading = false
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.loading = true
      this.getTotal()
    },
    getTotal() {
      SummaryPayroll({ id: this.personnel.id }, 'get', '').then(res => {
        this.total = (res.data.total === null) ? 0 : res.data.total
        this.totalOtherBenefits = (res.data.total.otherBenefits.total === null) ? 0 : this.total.otherBenefits.total
        this.totalbenefits = (res.data.total.benefits.total === null) ? 0 : this.total.benefits.total
        this.total_honorarium = 0
        if (this.withoutpay) {
          this.totaldeductions = (res.data.total.deduction.total === null) ? 0 : (this.total.deduction.total - this.withoutpay)
        } else {
          this.totaldeductions = (res.data.total.deduction.total === null) ? 0 : this.total.deduction.total
        }
        this.person = this.personnel
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.summary-amount {
  /*padding-left: 25px;*/
  text-align: right;
  width: 35%;
}
.summary-table {
  border-collapse: collapse;
}
.up-extra {
  background-color: lightblue;
}
.SBTotal {
  border-top: solid 1px;
  padding-top: 20px;
  font-weight: bold;
}
</style>
